<template>
  <div class="">
    <Breadcrumb :title="$t('miga.SelectService')" />
    <HeadingBox
      :title="$t('selectservice.title')"
      :description="$t('selectservice.description')"
    />
    <DatosIntroducidos />
    <ListBox
      :heading="$t('selectservice.title')"
      :loading="loading"
      :items="services"
      title="name"
      description="description"
      icons_attribute="icons"
      :onSelect="onSelect"
    />
    <NavButton anterior="SelectQueue" />
  </div>
</template>
<script>
import Vue from 'vue';
import Breadcrumb from "@/components/Breadcrumb";
import HeadingBox from "@/components/HeadingBox";
import DatosIntroducidos from "../components/DatosIntroducidos";
import ListBox from "../components/ListBox";
import NavButton from "../components/NavButton";

import APIPortal from "@/services/APIPortal.js";
import Session from "@/session/Session.js";

export default {
  name: "SelectService",
  components: {
    Breadcrumb,
    HeadingBox,
    DatosIntroducidos,
    ListBox,
    NavButton
  },
  data: () => ({
    queue: Session.getQueue(),
    services: [],
    loading: false
  }),
  beforeDestroy() {
    window.removeEventListener('language.changed', this.init);
  },

  async mounted() {
    window.addEventListener("language.changed", () => Vue.nextTick(this.init));
    this.init();
  },

  methods: {
    async init () {
      this.services.splice(0, this.services.length)
      this.loading = true
      window.console.log('SelectService', Session.getQueue())
      let res = await APIPortal.servicepointbyQueue(Session.getQueue().id, "m");
      this.services = res.data
        .filter((s) => s.supportsAppointments)
        .filter((s) => s.enPlazoSolicitud);

      this.services = window._.sortBy(this.services, ["name"], ["asc"]);

      window._.each(this.services, (s) => {
        s.icons = [];
        if (s.supportsOffice) s.icons.push("fas fa-people-arrows");
        if (s.supportsCallMe) s.icons.push("fa fa-phone");
        if (s.supportsVideoconference) s.icons.push("fa fa-tv");
      });
      this.loading = false
    },
    onSelect(s) {
      Session.setServicePoint(s);
      window.console.log("onServicePointSelect>", s);
      this.$router.push({ name: 'SelectChannel' });
    },
  },
};
</script>

<style scoped>
</style>
